import React from 'react';

class Container extends React.Component {
  render() {
    return (
      <div className="page-videos" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              {this.props.children}
              </div>
            </div>
          </div>
      </div>
    );
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/components/container/Container.js